import { motion } from "framer-motion";
import { ShieldCheck, Leaf, Heart, Users, Factory, Sparkles } from "lucide-react";
import { SectionHeader } from "@/components/sections/SectionHeader";

const ITEMS = [
  { icon: ShieldCheck, title: "Control calitate", desc: "Verificat la fiecare etapă, de la ingrediente la livrare." },
  { icon: Leaf, title: "Ingrediente selectate", desc: "Lucrăm cu furnizori în care avem încredere." },
  { icon: Heart, title: "Fără compromis la gust", desc: "Rețetele nu se reduc niciodată pentru cost." },
  { icon: Users, title: "Produse pentru toate vârstele", desc: "Gust echilibrat, plăcut, accesibil." },
  { icon: Factory, title: "Proces adaptat HoReCa", desc: "Gândit pentru cantități, flux și siguranță." },
  { icon: Sparkles, title: "Prospețime și stabilitate", desc: "Produsele rezistă, gustul rămâne." },
];

export default function Safety() {
  return (
    <section data-testid="safety-section" className="section-pad bg-bg">
      <div className="max-w-7xl mx-auto container-px">
        <SectionHeader
          eyebrow="Siguranță alimentară și calitate"
          title="Gust bun, dar și siguranță."
          subtitle="Un produs alimentar trebuie să fie gustos, dar mai ales sigur. La DOTAPAN, controlul calității face parte din fiecare etapă: de la ingrediente până la produsul final."
          testId="safety-header"
        />
        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {ITEMS.map((it, i) => (
            <motion.div
              key={it.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="card-soft p-7"
              data-testid={`safety-card-${i}`}
            >
              <div className="h-12 w-12 rounded-2xl bg-gold/10 border border-gold/30 flex items-center justify-center">
                <it.icon className="h-5 w-5 text-gold" />
              </div>
              <h3 className="mt-5 font-display text-xl text-text">{it.title}</h3>
              <p className="mt-2 text-sm text-text-soft leading-relaxed">{it.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
